import appReducer from './app.reducers'

export default appReducer
